/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { Component } from 'react';
import { PhoneNumber } from '../../../../ui/NewForm/index';
import * as Styles from './index.style';
import phoneIcon from './phoneIcon.svg';
import { get } from 'lodash';
import { Formik } from 'formik';
import Axios from 'axios';
import Cookies from 'universal-cookie';
import { Icon } from '../../../../ui/Icon';
import AnimFormButton, { FormStateArr } from '../../../AnimFormButton';
import { DEFAULT_COUNTRY } from '../../../../../utils/constants';
export default class PhoneInputForm extends Component {
  cookies = new Cookies();
  channelCookie = this.cookies.get('channel_attrib') || 'Organic';
  state = {
    alert: { msgType: '', msg: '' },
    formState: FormStateArr.DEFAULT,
  };

  onSubmit = async (values, { setSubmitting, resetForm, setFieldError }) => {
    const { fields } = this.props;

    const SubmissionEndpointApiUrl = get(
      fields,
      'fields.SubmissionEndpointApiUrl.value',
      '',
    );
    const formSuccessMsg = get(fields, 'fields.SuccessMessage.value', '');
    const formFailMsg = get(fields, 'fields.ErrorMessage.value', '');
    const PhoneNumberParameterName = get(
      fields,
      'fields.PhoneNumberParameterName.value',
      '',
    );
    const PhoneNumberInvalidErrorMessage = get(
      fields,
      'fields.PhoneNumberInvalidErrorMessage.value',
      '',
    );

    var phoneVal = values.phoneNumber;
    this.setState({
      alert: { msgType: '', msg: '' },
      formState: FormStateArr.PROGRESS,
    });
    // setSubmitting(false);
    // resetForm();
    // return;

    let isValidPhone = false;
    try {
      let CountryISOCode2 = this.countryData.CountryISOCode2;
      // let CountryISOCode3 = this.countryData.CountryISOCode3;
      let phoneNumber = values.phoneNumber;
      let apiURL = '/api/v1/form/validatecountryphonenumber';
      let postData = {
        countryISOCode2: CountryISOCode2,
        phoneNumber: phoneNumber,
      };

      if (this.cancelTokenSource) {
        // Cancel request
        this.cancelTokenSource.cancel();
      }
      this.cancelTokenSource = Axios.CancelToken.source();
      let isValidNumber = await Axios.post(apiURL, postData);
      if (isValidNumber.status !== 200) {
        setFieldError('phoneNumber', PhoneNumberInvalidErrorMessage);
        setSubmitting(false);
        this.setState({
          formState: FormStateArr.DEFAULT,
        });
      } else {
        isValidPhone = true;
      }
    } catch (error) {
      setFieldError('phoneNumber', PhoneNumberInvalidErrorMessage);
      setSubmitting(false);
      this.setState({
        formState: FormStateArr.DEFAULT,
      });
    }

    if (isValidPhone) {
      try {
        let formData = {};
        formData[PhoneNumberParameterName] = phoneVal;
        formData['DomainCountryISOCode2'] = this.countryData.CountryISOCode2;
        formData['CountryISOCode3'] = this.countryData.CountryISOCode3;
        formData['ChannelAttrib'] = this.channelCookie;

        const result = await Axios.post(
          window.location.origin + '/' + SubmissionEndpointApiUrl,
          formData,
        );
        if (result.status == 200) {
          this.setState({
            alert: { msgType: 'success', msg: formSuccessMsg },
            formState: FormStateArr.SUCCESS,
          });
          setSubmitting(false);
          resetForm();
        } else {
          this.setState({
            alert: { msgType: 'error', msg: formFailMsg },
            formState: FormStateArr.ERROR,
          });
          setSubmitting(false);
        }
      } catch (error) {
        this.setState({
          alert: { msgType: 'error', msg: formFailMsg },
          formState: FormStateArr.ERROR,
        });
        setSubmitting(false);
      }
    }
  };

  onFocus = () => {
    this.setState({
      formState: FormStateArr.DEFAULT,
      alert: { msgType: '', msg: '' },
    });
  };

  setCountryData = countryData => {
    this.countryData = countryData;
  };

  render() {
    const { isDarkMode, fields } = this.props;
    console.log('zz PhoneInputForm>>>>', fields);

    const Title = get(fields, 'fields.Title.value', '');
    const Introduction = get(fields, 'fields.Introduction.value', '');
    const CTAText = get(fields, 'fields.CTAText.value', '');
    const CallUsText = get(fields, 'fields.CallUsText.value', '');
    const CallUsNumber = get(fields, 'fields.CallUsNumber.value', '');
    const PhoneNumberWatermark = get(
      fields,
      'fields.PhoneNumberWatermark.value',
      '',
    );

    const PhoneNumberValidationRegex = get(
      fields,
      'fields.PhoneNumberValidationRegex.value',
      '',
    );
    const PhoneNumberOptions = get(fields, 'PhoneNumberOptions', []);
    const DomainCountryISOCode2 = get(
      fields,
      'DomainCountryISOCode2.value',
      DEFAULT_COUNTRY,
    );

    const PhoneNumberRequiredErrorMessage = get(
      fields,
      'fields.PhoneNumberRequiredErrorMessage.value',
      '',
    );
    const {
      alert: { msgType, msg },
      formState,
    } = this.state;

    return (
      <div
        css={[
          Styles.commonCss,
          isDarkMode ? Styles.DarkModeCss : Styles.LightModeCss,
        ]}
      >
        <h3>{Title}</h3>
        <p>{Introduction}</p>

        <Formik
          initialValues={{ phoneNumber: '' }}
          // validationSchema={validationSchema}
          validate={values => {
            const errors = {};
            // errors.phoneNumber = 'test';
            if (!values.phoneNumber.trim()) {
              errors.phoneNumber = PhoneNumberRequiredErrorMessage;
            }

            return errors;
          }}
          onSubmit={this.onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} data-formname="talkToAnExpertForm">
              <div className="callmesec">
                <PhoneNumber
                  options={PhoneNumberOptions}
                  className="inputphone"
                  id={'phoneNumber'}
                  selectInputid="countryCode"
                  defaultValue={DomainCountryISOCode2}
                  placeholder={PhoneNumberWatermark}
                  onInit={({ countryData }) => this.setCountryData(countryData)}
                  onChange={handleChange}
                  onChangeProp={(_event, countryData) =>
                    this.setCountryData(countryData)
                  }
                  error={errors.phoneNumber && touched.phoneNumber}
                  errorMessage={errors.phoneNumber}
                  inputProps={{
                    'data-testid': 'phone-input',
                    value: values.phoneNumber,
                    disabled: isSubmitting,
                  }}
                  inputOnFocus={this.onFocus}
                  selectProps={{
                    'data-testid': 'phone-dropdown',
                    disabled: isSubmitting,
                  }}
                />

                <AnimFormButton
                  label={CTAText}
                  formState={formState}
                  buttonProps={{
                    type: 'submit',
                    onClick: this.onFocus,
                    disabled: isSubmitting,
                    css: [],
                  }}
                />
              </div>
              {msgType && (
                <div css={[Styles.msgBox, msgType && Styles[msgType]]}>
                  {msg}
                </div>
              )}
            </form>
          )}
        </Formik>

        <div className="c1_call_sec">
          {/* <b>{this.fields.SecondaryHeading}</b> */}
          <span className="call_no">
            <a href={`tel:${CallUsNumber}`}>
              {CallUsText}
              <Icon name="contact" className="phone-default-icon" />
              <span className="number">{CallUsNumber}</span>
            </a>
          </span>
        </div>
      </div>
    );
  }
}
